/**
 * Created by jason on 2022/6/1.
 */
import {useEffect, useLayoutEffect} from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
